<template>
	<div class="finance container-fluid py-0 px-2">
		<div class="row">
			<div class="col-md-12 p-0">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>PL UNIT</strong></span>

					</div>
					<div>
                        <div class="row">
							<div class="mb-3">          
								<el-collapse style="margin-top: -21px;">
									<el-collapse-item>
										<template slot="title">
											<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
										</template>
										<el-form label-position="top" label-width="100px" class="ml-2">
                                            <div class="row">
												<div class="col-md-3">
													<el-form-item label="Bulan:">
														<el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                                            <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                                            </el-option>
                                                        </el-select>
													</el-form-item>
												</div>
												<div class="col-md-2">
													<el-form-item label="Tahun:">
														<el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                                            <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                                            </el-option>
                                                        </el-select>
													</el-form-item>
												</div>
                                                <div class="col-md-3">
                                                    <el-form-item label="Group:">
                                                        <el-radio-group v-model="group" size="small" name="group">
                                                            <el-radio-button :label="item5.value" v-for="(item5, index5) in options.group" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                        </el-radio-group>
                                                    </el-form-item>
                                                </div>
                                                <div class="col-md-2">	
                                                    <el-form-item label=" ">
                                                        <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                                                    </el-form-item>
                                                </div>
                                            </div>

										</el-form>
									</el-collapse-item>
								</el-collapse>
							</div>
						</div>

						<div class="mb-0" style="margin-top:0px;">   
							<div class="mt-0 ml-2 mr-2">
                                <ReportResultTable v-if="false" :reportname="'PLReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
                                <div class="row">
                                    <div class="col-md-12 text-right mb-1 px-0">
                                        <el-button type="success" size="medium" @click="exportToExcel()">Export to Excel</el-button>
                                    </div>                                 
                                </div>
                                <div class="row">
                                    <div class="col-md-12 pr-0 pl-0" :style="'overflow-x: auto; min-height:150px;height:' + tableHeight + ';'">
                                        <table class="app-table">
                                            <thead>
                                                <tr>
                                                    <th v-for="(value, key, idx) in summaryData" :key="key" :class="classHeaderColumn1(idx)" >   
                                                        <div :style="{ 'font-size': '17px', 'color': (key == 'AL500' ? (parseFloat(countTotal(value, key, idx).replace(/,/g, '')) < 0 ? 'red' : 'white') : 'white'), 'font-weight':'600' }">
                                                            {{ countTotal(value, key, idx) }}
                                                        </div>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th v-for="(item, idx) in reportdata.columns" :key="idx" :class="classHeaderColumn2(idx)">   
                                                        <div v-if="idx == 2" class="filter-popover column-fungsi">
                                                            <div>{{ item.title }}</div>
                                                            <el-popover placement="bottom" width="450" v-model="popovervisibility.fungsi">
                                                                <div class="row p-2">
                                                                    <div class="col-md-12">
                                                                        <h5>Fungsi</h5>
                                                                        <!--<el-input v-model="searchTextFungsi" placeholder="Search Fungsi"></el-input>-->
                                                                        <hr style="margin: 0px;">
                                                                        <!--
                                                                        <el-checkbox v-model="selectAllFungsi" @change="handleSelectAllFungsi">Check All</el-checkbox>
                                                                        <hr>
                                                                        <div style="max-height: 400px; overflow-y: auto;">
                                                                            <el-checkbox-group v-model="selectedOptionsFungsi">
                                                                                <el-checkbox v-for="option in filteredOptionsFungsi" :key="option.Fungsi" :label="option.Fungsi">
                                                                                    <div class="checkbox-text">{{ option.Fungsi }}</div>
                                                                                </el-checkbox>
                                                                            </el-checkbox-group>
                                                                        </div>
                                                                        <hr>
                                                                        -->


                                                                        
                                                                        <div style="max-height: 400px; overflow-y: auto;">
                                                                            <el-collapse>
                                                                                <el-collapse-item name="1">
                                                                                    <template slot="title">
                                                                                        <el-checkbox v-model="selectAllFungsiGroupFuel" @change="handleSelectAllFungsiGroupFuel()" class="mr-2"></el-checkbox><span style="font-size:16px;font-weight:bold;">FUEL</span>
                                                                                    </template>
                                                                                    <div class="mb-0">                                                                                                                                                              
                                                                                        <el-checkbox-group v-model="selectedOptionsFungsiGroupFuel" class="mb-3" style="margin-left:25px;">
                                                                                            <el-checkbox v-for="option in options.fungsigroup.fuel.Items" :key="option.Value" :label="option.Value">
                                                                                                <div class="checkbox-text">{{ option.Name }}</div>
                                                                                            </el-checkbox>
                                                                                        </el-checkbox-group>
                                                                                    </div>
                                                                                </el-collapse-item>

                                                                                <el-collapse-item name="2">
                                                                                    <template slot="title">
                                                                                        <el-checkbox v-model="selectAllFungsiGroupNonFuel" @change="handleSelectAllFungsiGroupNonFuel()" class="mr-2"></el-checkbox> <span style="font-size:16px;font-weight:bold;">NON FUEL</span>
                                                                                    </template>
                                                                                    <div class="mb-0">
                                                                                                                                                           
                                                                                        <el-checkbox-group v-model="selectedOptionsFungsiGroupNonFuel" class="mb-3" style="margin-left:25px;">
                                                                                            <el-checkbox v-for="option in options.fungsigroup.nonfuel.Items" :key="option.Value" :label="option.Value">
                                                                                                <div class="checkbox-text">{{ option.Name }}</div>
                                                                                            </el-checkbox>
                                                                                        </el-checkbox-group>
                                                                                    </div>
                                                                                </el-collapse-item>

                                                                                <el-collapse-item name="3">
                                                                                    <template slot="title">
                                                                                        <el-checkbox v-model="selectAllFungsiGroupHO" @change="handleSelectAllFungsiGroupHO()" class="mr-2"></el-checkbox> <span style="font-size:16px;font-weight:bold;">HO</span>
                                                                                    </template>
                                                                                    <div class="mb-0">
                                                                                                                                                            
                                                                                        <el-checkbox-group v-model="selectedOptionsFungsiGroupHO" class="mb-3" style="margin-left:25px;">
                                                                                            <el-checkbox v-for="option in options.fungsigroup.ho.Items" :key="option.Value" :label="option.Value">
                                                                                                <div class="checkbox-text">{{ option.Name }}</div>
                                                                                            </el-checkbox>
                                                                                        </el-checkbox-group>
                                                                                    </div>
                                                                                </el-collapse-item>

                                                                                <el-collapse-item name="4">
                                                                                    <template slot="title">
                                                                                        <el-checkbox v-model="selectAllFungsiGroupPitsa" @change="handleSelectAllFungsiGroupPitsa()" class="mr-2"></el-checkbox><span style="font-size:16px;font-weight:bold;">PITSA</span>
                                                                                    </template>
                                                                                    <div class="mb-0">
                                                                                                                                                           
                                                                                        <el-checkbox-group v-model="selectedOptionsFungsiGroupPitsa" class="mb-3" style="margin-left:25px;">
                                                                                            <el-checkbox v-for="option in options.fungsigroup.pitsa.Items" :key="option.Value" :label="option.Value">
                                                                                                <div class="checkbox-text">{{ option.Name }}</div>
                                                                                            </el-checkbox>
                                                                                        </el-checkbox-group>
                                                                                    </div>
                                                                                </el-collapse-item>
                                                                            </el-collapse>
                                                                        </div>
                                                                    
                                                                        <hr style="margin-top: 0px;">
                                                                        <el-button type="primary" @click="submitSelection('fungsi')" style="float:right;min-width: 130px;">Apply</el-button>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                            </el-popover>
                                                        </div>
                                                        <div v-else-if="idx == 3" class="filter-popover column-tipe">
                                                            <div>{{ item.title }}</div>
                                                            <el-popover placement="bottom" width="450" v-model="popovervisibility.tipe">
                                                                <div class="row p-2">
                                                                    <div class="col-md-12">
                                                                        <h5>Tipe</h5>
                                                                        <el-input v-model="searchTextTipe" placeholder="Search Type"></el-input>
                                                                        <hr>
                                                                        <el-checkbox v-model="selectAllTipe" @change="handleSelectAllTipe">Check All</el-checkbox>
                                                                        <hr>
                                                                        <div style="max-height: 400px; overflow-y: auto;">
                                                                            <el-checkbox-group v-model="selectedOptionsTipe">
                                                                                <el-checkbox v-for="option in filteredOptionsTipe" :key="option.Tipe" :label="option.Tipe">
                                                                                    <div class="checkbox-text">{{ option.Tipe }}</div>
                                                                                </el-checkbox>
                                                                            </el-checkbox-group>
                                                                        </div>
                                                                        <hr>
                                                                        <el-button type="primary" @click="submitSelection('tipe')">Apply</el-button>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                            </el-popover>
                                                        </div>
                                                        <div v-else-if="idx == 4" class="filter-popover column-area">
                                                            <div>{{ item.title }}</div>
                                                            <el-popover placement="bottom" width="450" v-model="popovervisibility.area">
                                                                <div class="row p-2">
                                                                    <div class="col-md-12">
                                                                        <h5>Sales Area</h5>
                                                                        <el-input v-model="searchTextArea" placeholder="Search Sales Area"></el-input>
                                                                        <hr>
                                                                        <el-checkbox v-model="selectAllArea" @change="handleSelectAllArea">Check All</el-checkbox>
                                                                        <hr>
                                                                        <div style="max-height: 400px; overflow-y: auto;">
                                                                            <el-checkbox-group v-model="selectedOptionsArea">
                                                                                <el-checkbox v-for="option in filteredOptionsArea" :key="option.Name" :label="option.Value">
                                                                                    <div class="checkbox-text">{{ option.Name }}</div>
                                                                                </el-checkbox>
                                                                            </el-checkbox-group>
                                                                        </div>
                                                                        <hr>
                                                                        <el-button type="primary" @click="submitSelection('area')">Apply</el-button>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                            </el-popover>
                                                        </div>
                                                        <div v-else-if="idx == 5" class="filter-popover column-unit">
                                                            <div>{{ item.title }}</div>
                                                            <el-popover placement="bottom" width="400" v-model="popovervisibility.unit">
                                                                <div class="row p-2">
                                                                    <div class="col-md-12">
                                                                        <h5>Unit</h5>
                                                                        <el-input v-model="searchTextUnit" placeholder="Search Unit Name"></el-input>
                                                                        <hr>
                                                                        <el-checkbox v-model="selectAllUnit" @change="handleSelectAllUnit">Check All</el-checkbox>
                                                                        <hr>
                                                                        <div style="max-height: 350px; overflow-y: auto;">
                                                                            <el-checkbox-group v-model="selectedOptionsUnit">
                                                                                <el-checkbox v-for="option in filteredOptionsUnit" :key="option.CostCenter" :label="option.CostCenter">
                                                                                    <div class="checkbox-text">{{ option.UnitName }}</div>
                                                                                </el-checkbox>
                                                                            </el-checkbox-group>
                                                                        </div>
                                                                        <hr>
                                                                        <el-button type="primary" @click="submitSelection('unit')">Apply</el-button>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                            </el-popover>
                                                        </div>
                                                        <div v-else-if="idx==(reportdata.columns.length-9)">
                                                            <div>{{ item.title }}</div>
                                                            <el-popover placement="bottom" width="450" v-model="popovervisibility.labarugi">
                                                                <div class="row p-2">
                                                                    <div class="col-md-12">
                                                                        <h5>LABA RUGI</h5>
                                                                        <el-input v-model="searchTextLabaRugi" placeholder="Search"></el-input>
                                                                        <hr>
                                                                        <el-checkbox v-model="selectAllLabaRugi" @change="handleSelectAllLabaRugi">Check All</el-checkbox>
                                                                        <hr>
                                                                        <div style="max-height: 350px; overflow-y: auto;">
                                                                            <el-checkbox-group v-model="selectedOptionsLabaRugi">
                                                                                <el-checkbox v-for="option in filteredOptionsLabaRugi" :key="option.Value" :label="option.Value">
                                                                                    <div class="checkbox-text">{{ option.Name }}</div>
                                                                                </el-checkbox>
                                                                            </el-checkbox-group>
                                                                        </div>
                                                                        <hr>
                                                                        <el-button type="primary" @click="submitSelection('labarugi')">Apply</el-button>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference"  icon="el-icon-search"  size="mini" circle></el-button>
                                                            </el-popover>
                                                            <el-button icon="el-icon-d-caret" size="mini" class="ml-2" circle @click="sortColumn(item.field)"></el-button>
                                                        </div>
                                                        <div v-else>
                                                            {{ item.title }}
                                                            <el-button v-if="idx>5" icon="el-icon-d-caret" size="mini" class="ml-2" circle @click="sortColumn(item.field)"></el-button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item2, idx2) in this.filteredDataAll" :key="idx2" :class="' bg-tr'">
                                                    <td v-for="(item3, idx3) in reportdata.columns" :key="idx3" :class="classBodyColumn(idx2,idx3)" :style="idx3 > 5 ? 'min-width:200px;' : ''">
                                                        <div :style="'height: 100%;'" @click="showPLUNitDetail(idx3, reportdata.categories[idx3], item2['Plant'], item2['CostCenter'])" :class="classBodyColumnCell(idx2,idx3,item2,item3)">
                                                            {{ (idx3 > 5 ? formatNum(item2[item3.field]) : item2[item3.field]) }} {{ idx3>=(reportdata.columns.length-6) ? '%' : '' }}
                                                        </div>                                                  
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                    </div>
                                </div>
                            </div>
                            <Loader v-if="loading.table"/>
						</div>
					</div>
				</el-card>	
			</div>
		</div>

        <el-dialog
            :title="categoryTitle"
            :visible.sync="dialogVisible"
            width="98%"
            top="10px"
            :lock-scroll="true"
            :before-close="handleClose">
            <span v-if="false">{{ categoryTitle }}</span>
            <div class="row mr-0 ml-0" style="margin-top:-35px;">
                <div class="col-md-12 pr-0 pl-0" style="overflow-x: auto;">
                    <PLUnitDetail :reportdata="reportdatadetail" v-if="loading.isSuccessDetail"/>
                    <!--
                    <table class="app-table" v-if="loading.isSuccessDetail">
                        <tr>
                            <th v-for="(item, idx) in reportdatadetail.columns" :key="idx" :class="idx > 5 ? '' : '' " :style="idx == 5 ? 'min-width:500px;' : '' ">
                                {{ item.title }}
                            </th>
                        </tr>
                        <tr v-for="(item2, idx2) in reportdatadetail.data" :key="idx2">
                            <td v-for="(item3, idx3) in reportdatadetail.columns" :key="idx3" :class="idx3 > 5 ? 'text-right' : ''">
                                <div style="background-color: transparent;" @click="showPLUNitDetail(idx3)">
                                    {{ (idx3 > 5 ? formatNum(item2[item3.field]) : item2[item3.field]) }}
                                </div>                                                  
                            </td>
                        </tr>
                    </table>
                    -->
                </div>
                <Loader v-if="loading.tableDetail" :style="'min-height: ' + tableHeight + ';'"/>
            </div>
        </el-dialog>

	</div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import Finance from '@/components/page/Finance.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

import PLUnitDetail from '@/views/pages/Finance/PLUnit/PLUnitDetail.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		ReportResultTable,
		//VendorReportTab,
		//FinanceReportTab,
        Loader,
        PLUnitDetail,
	},

	data(){
		return {
            loading: {
				table: false,
                tableDetail: false,
				chart: false,
				isSuccess: false,
                isSuccessDetail: false,
			},
            reportdata: [],
            reportdatadetail: [],
            urlRequestParams: '',
            dialogVisible: false,
            category: '',
            categoryTitle: '',
            unitId: '',
            station: {
                list: [],
            },

            tableHeight: "500px",

            month: ""+(Penanggalan().bulan > 1 ? Penanggalan().bulan-1 : Penanggalan().bulan),
            year: ""+Penanggalan().tahun,

            options: {
                fungsigroup: {
                    fuel: {
                        Value: 'fuel',
                        Name: 'FUEL',
                        Items: [
                            {
                                Value:'SPBU', 
                                Name:'SPBU', 
                            },
                            {
                                Value:'SPBG', 
                                Name:'SPBG', 
                            },
                            {
                                Value:'SPBUT', 
                                Name:'SPBUT', 
                            },
                            {
                                Value:'PERTASHOP', 
                                Name:'PERTASHOP', 
                            },
                            {
                                Value:'MODULAR', 
                                Name:'MODULAR', 
                            },
                            {
                                Value:'SPBU Sorong',
                                Name:'SPBU Sorong', 
                            },
                        ],
                    },
                    
                    nonfuel: {
                        Value: 'non_fuel',
                        Name: 'NON FUEL',
                        Items: [
                            {
                                Value:'Bright', 
                                Name:'Bright', 
                            },
                            {
                                Value:'Bright Alfa', 
                                Name:'Bright Alfa', 
                            },
                            {
                                Value:'Pelumas', 
                                Name:'Pelumas', 
                            },
                            {
                                Value:'LPG', 
                                Name:'LPG', 
                            },
                            {
                                Value:'SPKLU', 
                                Name:'SPKLU', 
                            },
                            {
                                Value:'Property', 
                                Name:'Property', 
                            },
                        ],
                    },
                    
                    ho: {
                        Value: 'ho',
                        Name: 'HO',
                        Items: [
                            {
                                Value:'Supply Chain', 
                                Name:'Supply chain', 
                            },
                            {
                                Value:'MD', 
                                Name:'MD', 
                            },
                            {
                                Value:'SAM', 
                                Name:'SAM', 
                            },
                            {
                                Value:'HO', 
                                Name:'HO', 
                            },
                            {
                                Value:'Non Bisnis', 
                                Name:'Non Bisnis', 
                            },
                        ],
                    },
                    
                    pitsa: {
                        Value: 'pitsa',
                        Name: 'PITSA',
                        Items: [
                            {
                                Value:'PITSA', 
                                Name:'PITSA', 
                            },
                        ],
                    },
                     
                },

                plant:[],
                costcenter:[],
                fungsi: [],
                tipe: [],
                unit: [],
                salesarea: [
                    { Value:'1', Name:'1' },
                    { Value:'2', Name:'2' },
                    { Value:'3', Name:'3' },
                    { Value:'4', Name:'4' },
                    { Value:'5', Name:'5' },
                ],
                labarugi: [
                    { Value:'profit', Name:'Profit (+)' },
                    { Value:'loss', Name:'Loss (-)' }
                ],
                group:[
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'ytd', name: 'YTD' },
				],

            },

            kolomheaders: {
                B500: 'TOTAL SALES',
                E500: 'TOTAL COST OF GOOD SOLD Incl. POTONG MARGIN',
                E501: 'GROSS MARGIN',
                G500: 'TOTAL LOSSES',
                Z500: 'TOTAL OPERATING EXPENSES',
                Z501: 'GROSS OPERATING PROFIT (GOP)',
                AD500: 'TOTAL DEPRECIATION AND AMORTIZATION',
                AF500: 'TOTAL OTHER OPERATING REVENUE',
                AK500: 'TOTAL OTHER INCOME (EXPENSES)',
                AL500: 'LABA/(RUGI) TAHUN BERJALAN',
                AL501: '*EBITDA',
                AM100: 'Volume Penjualan (L/LSP)',
                AN1: 'Persentase Total Margin Terhadap Sales',
                AN2: 'Operation Margin',
                AN3: 'Nett Margin',
                AN4: 'Persentase Losses Terhadap HPP',
                AN5: 'Biaya Operasi per Liter',
                AN6: 'OPEX to GM',
            },

            group : 'monthly',
            plant: '',
            costcenter: '',
            filteredDataAll: [],
            summaryData:[],
            sortOrder: 'desc',

            //old var
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0', 

			tabListCustomerReport:[
				{label:'Sales B2B', name: 'sales_b2b', index: '0' },
				{label:'Piutang', name: 'piutang', index: '1' },
			],

			tabListVendorReport:[
				{label:'Hutang', name: 'hutang', index: '10' },
			],

			tabListFinanceReport:[
				{label:'Cash Deposit Clearing', name: 'clearingcash', index: '20' },
				{label:'Kliring VA Pangkalan LPG', name: 'clearingedc', index: '21' },
			],

            popovervisibility: {
                fungsi: false,
                tipe: false,
                area: false,
                unit: false,
                labarugi: false,
            },

            //Fungsi
            selectAllFungsi:false,
            selectedOptionsFungsi: [],
            searchTextFungsi: "",

            //Tipe
            selectAllTipe:false,
            selectedOptionsTipe: [],
            searchTextTipe: "",

            //Sales Area
            selectAllArea:false,
            selectedOptionsArea: [],
            searchTextArea: "",

            //Unit filter
            selectedOptionsUnit: [], // Menyimpan opsi yang dipilih
            selectAllUnit: false, // Menyimpan status ceklis "Check All" dan "Uncheck All"
            searchTextUnit: "",

            //Laba Rugi
            selectAllLabaRugi:false,
            selectedOptionsLabaRugi: [],
            searchTextLabaRugi: "",
            
            //for paging
            itemsPerPage: 5,
            currentPage: 1,

            //Group Fungsi
            selectAllFungsiGroupFuel: false,
            selectedOptionsFungsiGroupFuel: [],

            selectAllFungsiGroupNonFuel: false,
            selectedOptionsFungsiGroupNonFuel: [],

            selectAllFungsiGroupHO: false,
            selectedOptionsFungsiGroupHO: [],

            selectAllFungsiGroupPitsa: false,
            selectedOptionsFungsiGroupPitsa: [],

		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
        this.setTableHeight();
        window.addEventListener("resize", this.setTableHeight);
        this.loadData()
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setTableHeight);
    },
    methods:{
        async loadData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/finance/pl-unit?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&group='+this.group

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
                    //this.filteredDataAll = response.data.data
					this.loading.isSuccess = true;

                    this.setEmptyFilter()

                    this.filteredAll()

                    //if(this.options.unit.length <=0) {
                        this.generateUnitList()
                        this.generateAreaList()
                        this.generateFungsiList()
                        this.generateTipeList()
                    //}

                    
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        async loadDataDetail() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/finance/pl-unit-detail?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&group='+this.group
			this.urlRequestParams+='&category='+encodeURIComponent(this.category)
            this.urlRequestParams+='&plant='+this.plant
            this.urlRequestParams+='&cost-center='+this.costcenter

			this.loading.tableDetail = true;
			this.loading.isSuccessDetail = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdatadetail = response.data;
					this.loading.isSuccessDetail = true;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.tableDetail = false;
				})
        },

        showPLUNitDetail(columnIndex, productCategory, plant, costCenter) {
            if(columnIndex > 5) {
                this.dialogVisible = true
                this.categoryTitle = productCategory
                this.category = productCategory
                this.plant = plant
                this.costcenter = costCenter
                this.loadDataDetail()
            }
        },

        generateFungsiList() {
			const groupedData = [];
			//this.reportdata.data.forEach((item) => {
            this.filteredDataAll.forEach((item) => {
				const branchKey = item.Fungsi //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						//CostCenter: item.CostCenter,
						Fungsi: item.Fungsi
					});
				}
			});

			this.options.fungsi = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        generateAreaList() {
			const groupedData = [];
			//this.reportdata.data.forEach((item) => {
            this.filteredDataAll.forEach((item) => {
				const branchKey = item.SalesArea //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						Value: item.SalesArea,
						Name: item.SalesArea
					});
				}
			});

			this.options.salesarea = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        generateTipeList() {
			const groupedData = [];
			//this.reportdata.data.forEach((item) => {
            this.filteredDataAll.forEach((item) => {
				const branchKey = item.Tipe //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						//CostCenter: item.CostCenter,
						Tipe: item.Tipe
					});
				}
			});

			this.options.tipe = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        generateUnitList() {
			const groupedData = [];
			//this.reportdata.data.forEach((item) => {
            this.filteredDataAll.forEach((item) => {
				const branchKey = item.CostCenter //`${item.CostCenter} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.CategoryName);
				} else {
					groupedData.push({
						branchKey,
						CostCenter: item.CostCenter,
						UnitName: item.UnitName
					});
				}
			});

			this.options.unit = groupedData
			//console.log('groupedData: ' + JSON.stringify(groupedData))

			//return groupedData;
		},

        handleClose(done) {
            this.$confirm('Are you sure to close ?')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },

		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },


        //filter
        showPopover() {
            this.$refs.myPopover.showPopper();
        },
        handleSelectAllUnit() {
            if (this.selectAllUnit) {
                this.selectedOptionsUnit = this.filteredOptionsUnit.map((option) => option.CostCenter);
            } else {
                this.selectedOptionsUnit = [];
            }
        },
        handleSelectAllArea() {
            if (this.selectAllArea) {
                this.selectedOptionsArea = this.filteredOptionsArea.map((option) => option.Name);
            } else {
                this.selectedOptionsArea = [];
            }
        },
        handleSelectAllTipe() {
            if (this.selectAllTipe) {
                this.selectedOptionsTipe = this.filteredOptionsTipe.map((option) => option.Tipe);
            } else {
                this.selectedOptionsTipe = [];
            }
        },
        handleSelectAllFungsi() {
            if (this.selectAllFungsi) {
                this.selectedOptionsFungsi = this.filteredOptionsFungsi.map((option) => option.Fungsi);
            } else {
                this.selectedOptionsFungsi = [];
            }
        },
        handleSelectAllLabaRugi() {
            if (this.selectAllLabaRugi) {
                this.selectedOptionsLabaRugi = this.filteredOptionsLabaRugi.map((option) => option.Value);
            } else {
                this.selectedOptionsLabaRugi = [];
            }
        },
        setEmptyFilter() {
            this.searchTextFungsi = ''
            this.searchTextTipe = ''
            this.searchTextUnit = ''
            this.searchTextLabaRugi = ''

            this.selectedOptionsFungsi = []
            this.selectedOptionsTipe = []
            this.selectedOptionsArea = []
            this.selectedOptionsUnit = []
            this.selectedOptionsLabaRugi = []

            this.selectAllFungsi = false
            this.selectAllTipe = false
            this.selectAllArea = false
            this.selectAllUnit = false
            this.selectAllLabaRugi = false
        },

        filteredAll() {
            /*
            let selectedFungsi = String(this.selectedOptionsFungsi || '').split(','); // hasil: ['PERTASHOP', 'SPBU']
            let selectedTipe = String(this.selectedOptionsTipe || '').split(',');
            let selectedArea = String(this.selectedOptionsArea || '').split(',');
            let selectedUnit = String(this.selectedOptionsUnit || '').split(','); // hasil: ['R2110743', 'R2110285']
            */

            let selectedOptionsFungsi = [...this.selectedOptionsFungsiGroupFuel, ...this.selectedOptionsFungsiGroupNonFuel, ...this.selectedOptionsFungsiGroupHO, ...this.selectedOptionsFungsiGroupPitsa]; //this.selectedOptionsFungsi
            let selectedFungsi = String(selectedOptionsFungsi || '').split(',').filter(Boolean);
            let selectedTipe = String(this.selectedOptionsTipe || '').split(',').filter(Boolean);
            let selectedArea = String(this.selectedOptionsArea || '').split(',').filter(Boolean);
            let selectedUnit = String(this.selectedOptionsUnit || '').split(',').filter(Boolean);
            let selectedLabaRugi = String(this.selectedOptionsLabaRugi || '').split(',').filter(Boolean);

            let filteredData = this.reportdata.data.filter(item => {
                // Check if the corresponding array is not empty before applying the filter
                return (selectedFungsi.length === 0 || selectedFungsi.includes(item.Fungsi))
                    && (selectedTipe.length === 0 || selectedTipe.includes(item.Tipe))
                    && (selectedArea.length === 0 || selectedArea.includes(item.SalesArea))
                    && (selectedUnit.length === 0 || selectedUnit.includes(item.CostCenter))
                    && (selectedLabaRugi.length === 0 || 
                        (selectedLabaRugi.includes('profit') && item.AL500 >= 0) ||
                        (selectedLabaRugi.includes('loss') && item.AL500 < 0)
                    );
                });

            /*
            console.log('selectedFungsi: ' + JSON.stringify(selectedFungsi))
            console.log('selectedTipe: ' + JSON.stringify(selectedTipe))
            console.log('selectedArea: ' + JSON.stringify(selectedArea))
            console.log('selectedUnit: ' + JSON.stringify(selectedUnit))
            console.log('Filtered Data:', JSON.stringify(filteredData));
            */

            this.filteredDataAll = filteredData
            this.generateSummary(filteredData)

            //regenerate filter options
            //this.generateUnitList()
            //this.generateFungsiList()
            //this.generateTipeList()
        },

        generateSummary(filteredData) {
            //Buat array summary
            let columns = this.reportdata.columns.map(column => column.field);
            //console.log('Columns:', columns);

            let summary = {};
            columns.forEach(column => {
                summary[column] = 0;
            });

            filteredData.forEach(item => {
                for (let key in summary) {
                    summary[key] += parseFloat(item[key] || 0);
                }
            });

            this.summaryData = summary

            //console.log('Summary for Columns: ' + JSON.stringify(summary)); 
        },

        countTotal(value,key,idx) {
            //console.log('value : ' + value)
            //console.log('key : ' + key)
            //console.log('idx : ' + idx)

            let totalSales = this.summaryData['B500']
            let grossMargin = this.summaryData['E501']
            let operatingExpense = this.summaryData['Z500']
            let labaRugi = this.summaryData['AL500']
            let totalVolume = this.summaryData['AM100']

            let val = this.formatNum(value)
            if(key == 'AN1') { //PERSENTASE TOTAL MARGIN TERHADAP SALES
                val = this.formatNum((grossMargin/totalSales) * 100) + '%'
            } else if(key == 'AN2') { //Operation Margin
                val = this.formatNum((operatingExpense/totalSales) * 100) + '%'
            } else if(key == 'AN3') { //Nett Margin
                val = this.formatNum((labaRugi/totalSales) * 100) + '%'
            } else if(key == 'AN4') { //LOSSES TERHADAP HPP
                val = '' //Set empty
            } else if(key == 'AN5') { //Biaya Operasi per Liter
                val = '' //this.formatNum((operatingExpense/totalVolume)) + '%'
            } else if(key == 'AN6') { //OPEX to GM
                val = this.formatNum((operatingExpense/grossMargin)* 100) + '%'
            }

            return idx > 5 ? val : ''
        },

        submitSelection(actionname) {
            //console.log('Opsi yang dipilih:', this.selectedOptionsUnit);
            // hide popover
            this.closePopover()
            this.filteredAll()

            if(actionname == 'fungsi') {
                this.generateUnitList()
                this.generateTipeList()
                this.generateAreaList()
            } else if(actionname == 'tipe') {
                this.generateUnitList()
                this.generateFungsiList()
                this.generateAreaList()
            } else if(actionname == 'area') {
                this.generateFungsiList()
                this.generateTipeList()
                this.generateUnitList()
            } else if(actionname == 'unit') {
                this.generateFungsiList()
                this.generateTipeList()
                this.generateAreaList()
            }
        },

        sortColumn(field) {
            //let sortOrder = 'desc';
            //this.filteredDataAll = this.filteredDataAll.sort((a, b) => b[field] - a[field]);
            this.filteredDataAll = this.filteredDataAll.sort((a, b) => {
                                        const compareResult = this.sortOrder === 'desc' ? b[field] - a[field] : a[field] - b[field];
                                        return compareResult;
                                    });
            this.toggleSortOrder()
        },  

        toggleSortOrder() {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        },

        closePopover() {
            this.popovervisibility.fungsi = false
            this.popovervisibility.tipe = false
            this.popovervisibility.area = false
            this.popovervisibility.unit = false
            this.popovervisibility.labarugi = false
        },

        classHeaderColumn1(idx) {
            let cls = 'text-right sticky-table-header'
            if(idx == 0) {
                cls += ' column-plant sticky-column z-index-header'
            } else if(idx == 1) {
                cls += ' column-cost-center sticky-column-cost-center z-index-header' // sticky-column-cost-center
            } else if(idx == 2) {
                cls += ' column-fungsi sticky-column-fungsi z-index-header'
            } else if(idx == 3) {
                cls += ' column-tipe sticky-column-tipe z-index-header'
            } else if(idx == 4) {
                cls += ' column-area sticky-column-area z-index-header'
            } else if(idx == 5) {
                cls += ' column-unit sticky-column-unit z-index-header'
            } else {
                cls += ''
            }

            return cls //idx <= 4 ? 'text-right sticky-column sticky-table-header' : 'text-right sticky-table-header'
        },
        classHeaderColumn2(idx) {
            let cls = 'sticky-table-header2'
            if(idx == 0)
                cls += ' sticky-column z-index-header'
            else if(idx ==1)
                cls += ' sticky-column-cost-center z-index-header' //sticky-column-cost-center
            else if(idx == 2) {
                cls += ' sticky-column-fungsi z-index-header'
            } else if(idx == 3) {
                cls += ' sticky-column-tipe z-index-header'
            } else if(idx == 4) {
                cls += ' sticky-column-area z-index-header'
            } else if(idx == 5) {
                cls += ' sticky-column-unit z-index-header'
            } 

            if(idx > 5 && idx <= (this.reportdata.columns.length-8))
                cls += ' th-yellow'
            return cls //idx > 5 ? 'th-yellow sticky-table-header2' : 'sticky-table-header2'
        },

        classBodyColumn(idxrow, idxcolumn) {
            let cls = ''

            if(idxrow%2==0) {
                cls += ' bg-even'
            } else {
                cls += ' bg-odd'
            }

            if(idxcolumn == 0)
                cls += ' sticky-column-row z-index-body'
            else if(idxcolumn == 1)
                cls += ' sticky-column-cost-center z-index-body' //sticky-column-cost-center
            else if(idxcolumn == 2)
                cls += ' sticky-column-fungsi z-index-body'
            else if(idxcolumn == 3)
                cls += ' sticky-column-tipe z-index-body'
            else if(idxcolumn == 4)
                cls += ' sticky-column-area z-index-body'
            else if(idxcolumn == 5)
                cls += ' sticky-column-unit z-index-body'
            else if(idxcolumn>5)
                cls += ' text-right'
            return cls //idxcolumn > 5 ? 'text-right' : ''
        },

        classBodyColumnCell(idx2, idx3, itemrow, itemcolumn) {
            
            let cls = ''
            if(idx3 > 5) {
                cls += ' button-cell'
            }

            if(itemcolumn.field == 'AL500') { 
                //LABA RUGI
                if(itemrow[itemcolumn.field] >= 0)
                    cls += ' font-color-green'
                else
                    cls += ' font-color-red'

                //console.log('itemcolumn: ' + JSON.stringify(itemcolumn))
            }

            return cls
        },

        setTableHeight() {
            // Dapatkan tinggi layar
            const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            let screenHeightDiv = screenHeight - 220;
            // Sesuaikan tinggi tabel sesuai dengan tinggi layar
            this.tableHeight = `${screenHeightDiv}px`;
        },

        //for paging
        setCurrentPage(pageNumber) {
            this.currentPage = pageNumber;
        },

        handleSelectAllFungsiGroupFuel() {
            if (this.selectAllFungsiGroupFuel) {
                this.options.fungsigroup.fuel.Items.forEach(item=> {
                    this.selectedOptionsFungsiGroupFuel.push(item.Value)
                })
            } else {
                this.selectedOptionsFungsiGroupFuel = [];
            }
        },

        handleSelectAllFungsiGroupNonFuel() {
            if (this.selectAllFungsiGroupNonFuel) {
                this.options.fungsigroup.nonfuel.Items.forEach(item=> {
                    this.selectedOptionsFungsiGroupNonFuel.push(item.Value)
                })
            } else {
                this.selectedOptionsFungsiGroupNonFuel = [];
            }
        },

        handleSelectAllFungsiGroupHO() {
            if (this.selectAllFungsiGroupHO) {
                this.options.fungsigroup.ho.Items.forEach(item=> {
                    this.selectedOptionsFungsiGroupHO.push(item.Value)
                })
            } else {
                this.selectedOptionsFungsiGroupHO = [];
            }
        },

        handleSelectAllFungsiGroupPitsa() {
            if (this.selectAllFungsiGroupPitsa) {
                this.options.fungsigroup.pitsa.Items.forEach(item=> {
                    this.selectedOptionsFungsiGroupPitsa.push(item.Value)
                })
            } else {
                this.selectedOptionsFungsiGroupPitsa = [];
            }
        },

        applyFilter() {
            this.loadData()
        },

        exportToExcel() {
            //console.log('export to excel');
            let data = this.filteredDataAll; // this.reportdata?.data;

            // Convert JSON data to an HTML table
            const tableHTML = this.convertJSONToTable(data);

            // Create a Blob object with the table HTML content
            const blob = new Blob([tableHTML], {
                type: "application/vnd.ms-excel",
            });

            // Create a download link
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "PL Unit " + this.month + " " +this.year + ".xls");

            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        convertJSONToTable(jsonData) {
            let table = "<table border='1'>";

            // Create table headers
            const headers = Object.keys(jsonData[0]);
            table += "<tr>";
            headers.forEach((header) => {
                let titleheader = this.kolomheaders[header] || header;
                table += `<th>${titleheader}</th>`;
            });
            table += "</tr>";

            // Create table rows
            jsonData.forEach((row) => {
                table += "<tr>";
                Object.values(row).forEach((cell) => {
                if (this.isNumberString(cell)) {
                    // Make sure Excel treats it as a number with decimal places
                    //table += `<td style="mso-number-format:'0.00000000';">${cell.replace(".", ",")}</td>`;
                    table += `<td>${cell.replace(".", ",")}</td>`;
                } else {
                    table += `<td>${cell}</td>`;
                }
                });
                table += "</tr>";
            });

            table += "</table>";
            return table;
        },

        isNumberString(value) {
            return !isNaN(value) && !isNaN(parseFloat(value));
        }

    },
    computed: {
        filteredOptionsFungsi() {
            const lowerSearch = this.searchTextFungsi.toLowerCase();
            return this.options.fungsi.filter(
                (option) =>
                String(option.Fungsi).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsTipe() {
            const lowerSearch = this.searchTextTipe.toLowerCase();
            return this.options.tipe.filter(
                (option) =>
                String(option.Tipe).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsArea() {
            const lowerSearch = this.searchTextArea.toLowerCase();
            return this.options.salesarea.filter(
                (option) =>
                String(option.Value).toLowerCase().includes(lowerSearch) ||
                String(option.Name).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsUnit() {
            const lowerSearch = this.searchTextUnit.toLowerCase();
            return this.options.unit.filter(
                (option) =>
                String(option.CostCenter).toLowerCase().includes(lowerSearch) ||
                String(option.UnitName).toLowerCase().includes(lowerSearch)
            );
        },
        filteredOptionsLabaRugi() {
            const lowerSearch = this.searchTextLabaRugi.toLowerCase();
            return this.options.labarugi.filter(
                (option) =>
                String(option.Value).toLowerCase().includes(lowerSearch)
            );
        },
        
        //for paging
        paginatedData() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.filteredDataAll.slice(startIndex, endIndex);
        },
        totalPages() {
            return Math.ceil(this.filteredDataAll.length / this.itemsPerPage);
        }
        
    },
}
</script>

<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.app-table {
    /*
    height: 100px;
    overflow-y: auto;
    */

  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
  border: 2px solid #fff;
  border-spacing: 2px;
}

.app-table td, .app-table th {
    
    vertical-align: middle;
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background: #F1F4F8/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background:rgba(240, 240, 240, 1)  /*#ddd*/;}

.app-table th {
  padding-top: 3px;
  padding-bottom: 3px;
  font-size: 13px;
  text-align: center;
  background-color: #0B0468/*#0070C0*/;
  color: white;
}

.bg-even {
    background: #fff;
}

.bg-odd {
    background: #F1F4F8;
}

.bg-tr:hover {
    background: #0B0468;
}

.sticky-table-header {
    position: sticky;
    top: 1px;
    background-color: #f8f8f8;
    /*z-index: 1000;*/
  }

  .sticky-table-header2 {
    position: sticky;
    top: 29px;
    background-color: #f8f8f8;
    /*z-index: 1000;*/
  }

.th-yellow {
    font-weight:bold;
    color:#1E1E1E !important;
    font-size:12px !important;
    background: #FFFF00 !important;
}

.el-dialog__body {
    word-break: normal !important;
}

.button-cell {
    border-radius: 2px;
    cursor: pointer;
    overflow:auto;
    -moz-box-sizing: border-box;
}

.button-cell:hover {
    background: #FFFF00 !important;
    border-radius: 2px;
    color:#1E1E1E !important;
    cursor: pointer;
}

.el-dialog {
    border-radius: 6px !important;
}


.checkbox-text  {
    max-width: 350px; /* Sesuaikan dengan lebar yang diinginkan */
    padding-top:5px;
    padding-bottom:5px;
    text-overflow: ellipsis;
   
    white-space: nowrap;  
}


.filter-popover {
  display: flex;
  align-items: center;
  justify-content: center; /* Mengatur horizontal alignment */
}

.filter-popover > * {
  margin-right: 0px; /* Sesuaikan dengan jarak yang diinginkan antar elemen */
  margin-left: 10px;
}


.sticky-column {
    position: sticky;
    left: 1px;
    z-index: 21;
    background-color: #fff; /* Set background color to match your design */
}

.sticky-column-row {
    position: sticky;
    left: 1px;
    z-index: 10;
    /*background-color: #fff; */ /* Set background color to match your design */
}

.sticky-row {
    position: sticky;
    top: 0;
    z-index: 11;
    background-color: #fff; /* Set background color to match your design */
}

.column-plant {
    min-width: 60px;
    width: 60px;
}
.column-cost-center {
    min-width: 80px;
    width: 80px;
}
.column-fungsi {
    min-width: 80px;
    width: 80px;
}
.column-tipe {
    min-width: 80px;
    width: 80px;
}
.column-area {
    min-width: 80px;
    width:80px;
}
.column-unit {
    min-width: 350px;
    width: 350px;
}

.sticky-column-cost-center {
    position: sticky;
    left: 61px;
}

.sticky-column-fungsi {
    position: sticky;
    left: 142px;
}

.sticky-column-tipe {
    position: sticky;
    left: 244px;
}

.sticky-column-area {
    position: sticky;
    left: 346px;
}

.sticky-column-unit {
    position: sticky;
    left: 448px;
}

.z-index-header {
    z-index: 21;
}

.z-index-body {
    z-index: 20;
}

.font-color-red {
    color:red;
}

.font-color-green {
    color:#67C23A;
}

.el-collapse-item__content {
    padding-bottom: 10px !important;
}
</style>